import { mapState, mapActions } from "vuex";
import Empty from "../common/EmptyData.vue";
import JobNearby from "@/components/Nearby/JobNearby.vue"
import SwiperContainerH5 from './SwiperContainer-h5.vue'
import SwiperContainerPC from './SwiperContainer-pc.vue'
import SelectedSvg from './SelectedSvg.vue'
import ChangeSvg from "./ChangeSvg.vue";
import ReadMoreSvg from './ReadMoreSvg.vue'
import TabBar from './tabBar.vue'
// import data from './mock'
export default {
  name: "MulticolumnJobList",
  components: { Empty, SwiperContainerH5,SwiperContainerPC,JobNearby,SelectedSvg,TabBar,ChangeSvg,ReadMoreSvg },
  props: {
    pageConfig: {
      type: Object,
      default: () => { },
    },
    componentConfig: {
      type: Object,
      default: () => { },
    },
  
    goodRank: {
      default: () => {
        return "";
      },
    },
  },
  data() {
    return {
      urgentJobList: [],
      jobOrCompanyIdList: [], //下次请求列表带上次返回数组
      isShowDeliverys: true,// 是否展示一键投递, 初始化展示
      selectedJobIds: [], // 批量模式下被选中的投递卡片
      // 一键投递列表 排除网申和已投递
      delivarysJobList: [],
      pageNum: 1,
      pageSize: 4,
      totalPages: 0, //数据总页数
      loading: true,
      requestId: "",
      isFirstInit: false,
      mySwiper: null,
      curItem:{},//当前tab下的标签数据
      // coutKey: 0, // showCompontent控制触发次数
    };
  },
  computed: {
    ...mapState(["commonStore", "resumeStore"]),
    nearbyPopShow: {
      get() {
        return this.commonStore.nearbyPopShow;
      },
      set() {},
    },
    jobNeedNearby: {
      get() {
        return this.curItem?.showCondition==1 && !this.commonStore.lon;
      },
      set() {},
    },
    platform() {
      return this.commonStore.platform;
    },
    backgroundConfigDTO() {
      return this.componentConfig.backgroundConfigDTO;
    },
    moduleStyle() { // 1-职场人样式 2-学生样式 
      return (
        this.componentConfig?.jobTabComponentDTO?.moduleStyle
      );
    },
    buttonColor() { // 按钮的颜色
      const role = this.moduleStyle;
      const customBackground = this.backgroundConfigDTO.customBackground; 
      const buttonColor = this.backgroundConfigDTO?.buttonColor;
      return (
        role == '2' ? (customBackground == 1 && buttonColor ? buttonColor :'#fff') :  this.backgroundConfigDTO?.buttonColor || this.pageConfig.buttonColor
      );
    },
    tagColor() { //标签页颜色
      return (
        this.componentConfig?.jobTabComponentDTO?.tabColor || this.backgroundConfigDTO?.buttonColor  || this.pageConfig.buttonColor
      )
    },
    isForPC(){
      return this.commonStore.isForPC
    },
    moduleIconUrl() {
      if (this.commonStore.isForPC) {
        return (
          this.backgroundConfigDTO?.moduleIconPcUrl ||
          this.pageConfig.moduleIconPcUrl
        );
      } else {
        return (
          this.backgroundConfigDTO?.moduleIconUrl ||
          this.pageConfig.moduleIconUrl
        );
      }
    },
    jumpButtonConfig() {
      return this.curItem?.jumpButtonConfigDTO || {};
    },
    backgroundImage() {
      return this.moduleIconUrl;
    },
    needFilterJobs() {
      //是否当前组件需配置了推荐
      if (this.componentConfig.recommendConfigDTO) {  // recommendConfigDTO.needFilterJobs =true 或 null 时需要进行首页去重,ecommendConfigDTO.needFilterJobs  =  false 不进行去重
        if( this.componentConfig.recommendConfigDTO.needFilterJobs || this.componentConfig.recommendConfigDTO.needFilterJobs == null){
          return true;
        }else {
          return true;
        }
      } else if (
        this.pageConfig.recommendConfigDTO &&
        this.pageConfig.recommendConfigDTO.needFilterJobs
      ) {
        return true;
      } else {
        return false;
      }
    },
    tabList(){//标签列表
      return this.componentConfig?.jobTabComponentDTO?.jobTabList || [];
    },
    row(){
      return this.componentConfig?.jobTabComponentDTO?.showRowCount || 3;
    },
    column(){
      return this.componentConfig?.jobTabComponentDTO?.showColCount || 4;
    },
    isLastTab(){
      return (this.$refs.tabBarBox?.tagIndex || 0) < (this.tabList.length - 1) ? false:true;
    },
    selectButtonColor(){
      return '#fff'
    },
    showCompontent(){//是否显示整个组件,换一换不执行这个逻辑
      if(this.tabList.length <= 1 && this.urgentJobList?.length <= 0 && !this.jobNeedNearby && !this.isChangeTab){
        return false;
      }else{
        return true;
      }
    }
  },
  watch: {
    "commonStore.currentAreaCode": {
      handler() {
        this.isFirstInit = false;
        this.pageNum = 1;
        this.loading = true;
        this.jobOrCompanyIdList = [];
        this.urgentJobList = [];
        this.isChangeTab = false
        this.queryJobList();
      },
      immediate: false,
    },
    "commonStore.deweightComponentSort": {
      //监控去重顺序变更
      handler(val) { 
          if (val == this.componentConfig.deWeightSort ) {
            console.log("触发-----监控去重-----顺序变更2222222", val);
            console.log(
              "触发-----公司双列组件-----顺序",
              this.componentConfig.deWeightSort
            );
            this.isFirstInit = true;
            this.isChangeTab = false
            // 首屏去重职位逻辑:请求完数据,加载下一个需要去重的组件
            if (this.isFirstInit && this.jobNeedNearby && (this.$refs.tabBarBox?.tagIndex || 0) == 0 ) {
              //首次加载数据
              this.isFirstInit = false;
              this.$base.setFilterJobIds(
                this.componentConfig.deWeightSort,
                []
              );
            }
            this.queryJobList();
          }
        // }
      },
      immediate: false,
    },
  },
  mounted() {
    this.curItem = this.tabList[0];
    this.selectedInit();
  },
  methods: {
    handleTabChange(cui){
      this.curItem = cui;
      this.isFirstInit = false;
      this.pageNum = 1;
      this.loading = true;
      this.jobOrCompanyIdList = [];
      this.urgentJobList = [];
      this.selectedInit();
      this.queryJobList();
    },
     // 继续滑动到下一个专题
     viewMore() {
      if ((this.$refs.tabBarBox?.tagIndex || 0) < (this.tabList.length - 1)) {
        this.$refs.tabBarBox.jumpToBlock((this.$refs.tabBarBox.tagIndex+1),this.tabList[(this.$refs.tabBarBox.tagIndex+1)]);
      }
    },
    selectedInit() {
      this.selectedJobIds = [];
      this.isShowDeliverys = true;
    },
    cancelDeliverys() {
      if (this.urgentJobList.length > 0) {
        this.isShowDeliverys = !this.isShowDeliverys;
        if (this.isShowDeliverys) {
          this.setAllSelected();
        } else {
          this.removeAllSelected();
        }
      }
    },
    setAllSelected() {
      // 一键投递过滤网申和已投递和已过期的
      if (this.urgentJobList.length > 0) {
        this.selectedJobIds = this.urgentJobList.filter(item => !item.isFromXyx && !item.isApply && !item.isExpire).map(item => item.jobId);
      } else {
        this.selectedJobIds = [];
      }
    },
    removeAllSelected() {
      this.selectedJobIds = [];
    },
    // 点击职位卡片左上角复选框
    changeItemSelected(item) {
      // 已投递
      if (item.isApply) {
        this.$toast('您已投递该岗位了，无法选择批量投递哦');
        return;
      } else {
        // 一键投递
        if (item.isFromXyx) {
          //网申
          this.$toast('该职位不支持批量投递，请单独投递');
          return;
        } else {
          console.log('选中卡片');
        }
      }
      const isFromXyx = item.isFromXyx;
      const isApply = item.isApply;
      const isExpire = item.isExpire;
      if (!isFromXyx && !isApply && !isExpire) {
        const currentClickJobId = item.jobId;
        if (this.selectedJobIds.length > 0 && this.selectedJobIds.includes(currentClickJobId)) {
          this.selectedJobIds = this.selectedJobIds.filter(id => id != currentClickJobId);
        } else {
          this.selectedJobIds = [...this.selectedJobIds, currentClickJobId];
        }
        let allCanSelectList = this.urgentJobList.filter(item => !item.isFromXyx && !item.isApply && !item.isExpire).map(item => item.jobId);
        if (this.selectedJobIds.length === allCanSelectList.length) {
          this.isShowDeliverys = true;
        } else {
          this.isShowDeliverys = false;
        }

      }
    },
    cityStr(jobAreaString) {
      //截取城市字段
      jobAreaString = jobAreaString.split("·")[0];
      return jobAreaString;
    },
    
    welfare(jobTags) {
      return jobTags.join(",");
    },
    ...mapActions("applyJobStore", ["applyJob", "batchApplyJob"]),
    buildJobShortExposureParams(item, index) {
     

      if (this.goodRank !== "") {
        return this.$base.getJobShortExposureParams(
          item,
          index,
          this.urgentJobList.length,
          {
            subContentRank: this.goodRank,
          }
        );
      } else {
        return this.$base.getJobShortExposureParams(
          item,
          index,
          this.urgentJobList.length
        );
      }
    },
    // 职位列表
    async queryJobList(type = "default") {
      if(!this.curItem?.strategyId){
        return false;
      }
      const jobNumber =  this.isForPC ? 9 : this.row * this.column; 
      let filterJobIds = null;
      console.log("当前索引值",(this.$refs.tabBarBox?.tagIndex || 0))
      if((this.$refs.tabBarBox?.tagIndex || 0) === 0){//第一个tab走去重的逻辑
        if(this.isFirstInit && this.needFilterJobs){
          filterJobIds = JSON.parse(sessionStorage.getItem("filterJobIds")) || null;
        }
      }else{
        filterJobIds = sessionStorage.getItem("exposuredJobIds") ? JSON.parse(sessionStorage.getItem("exposuredJobIds")) : null;
      }
      const params = {
        strategyId:this.curItem?.strategyId,
        componentId: this.componentConfig?.id,
        cityCode: this.commonStore.currentAreaCode,
        funcCode: this.$route.query?.funcCode
          ? this.$route.query?.funcCode
          : this.commonStore.intention?.expectFunction || "",
        pageNum: this.pageNum,
        pageSize: jobNumber,
        requestId: this.requestId,
        jobOrCompanyIdList: this.jobOrCompanyIdList,
        workFuncStr: this.commonStore.intention?.expectFunctionString,
        expectWorkArea: this.commonStore.intention?.expectArea,
        expectIndustry: this.commonStore.intention?.expectIndustry,
        expectIndustryNew: this.commonStore.intention?.expectIndustry,
        expectMinSalary: this.commonStore.intention?.minSalary,
        expectMaxSalary: this.commonStore.intention?.maxSalary,
        busBelong: this.pageConfig.busBelong || "51job",
        seekType: this.commonStore.intention?.seekType || "",
        userIdentity:
          this.commonStore.identityType == "职场人"
            ? 0
            : this.commonStore.identityType == "在校生"
              ? 1
              : 0,
        degree: this.resumeStore.resume?.c.education[0]?.degree || "",
        major: this.resumeStore.resume?.c.education[0]?.major || "",
        filterJobIds:filterJobIds, //过滤ids
        resideCity: this.resumeStore.resume?.accountInfo?.area || "",
        lon: this.commonStore.lon || '',
        lat: this.commonStore.lat || '',
        radius: this.commonStore.radius || '',
        recommendStrategyCityCode: this.commonStore.currentExpandCityList
        
      };

      const { promoJobId } = this.$store.getters.getPromoJobId(this.componentConfig.sort);
      if (promoJobId) {
        params.promoJobId = promoJobId;
      }

      const property = {
        pageCode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}|${this.curItem?.strategyId}`,
        shortPageCode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}|${this.curItem?.strategyId}`,
      };
      if(this.jobNeedNearby){
        this.loading = false;
        return
      }
      const res = await this.$api.activity.getActivityJobList(params, {
        property,
      });
      // 首屏去重职位逻辑:请求完数据,加载下一个需要去重的组件
      if (this.isFirstInit) {
        //首次加载数据
        this.isFirstInit = false;
        this.$base.setFilterJobIds(
          this.componentConfig.deWeightSort,
          res.data?.jobInfoList?.result
        );
      }
      if (type == "readonly") {
        // 仅用于获取下一页数但不更新页码
        let result = [];
        if (res?.code == "0") {
          result = res.data.jobInfoList.result;
        }
        return result;
      }

      if (res?.code == "0") {
        this.loading = false;
        const { jobOrCompanyIdList, jobInfoList, requestId } = res.data;
        this.jobOrCompanyIdList = jobOrCompanyIdList;
        this.requestId = requestId;
        if (jobInfoList.result.length > 0) {
          this.totalPages = jobInfoList.totalPages;
          this.pageNum =
            this.pageNum < jobInfoList.totalPages ? this.pageNum + 1 : 1;
          this.urgentJobList = jobInfoList.result;
          this.delivarysJobList = this.urgentJobList.filter(
            (item) => !item.isFromXyx && !item.isApply && !item.isExpire
          );
          this.selectedJobIds = this.delivarysJobList.map(item=> item.jobId)
          this.isShowDeliverys = true;
        }

        if (!this.showCompontent) {
          console.log("多列滑动没数据走这里");
          this.$store.commit('subCountJobAndCompany');
        }
        this.$nextTick(() => {
          this.$exposure.sensorsExposure();
        });
      } else if (+res?.code == "9" && this.pageNum == 1) {
        // this.showCompontent = false
        this.$store.commit('subCountJobAndCompany')
      } else {
        this.urgentJobList = [];
        this.loading = false;
      }
    },
   
    handleChangeJob() {
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_joblist2_more",
        moduleName: `${this.componentConfig.sort}|${this.componentConfig.type}`,
        contentName: this.componentConfig.title,
        bcopExrinfo: {
          pagecode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}|${this.curItem?.strategyId}`,
        },
        contentType: "刷新职位",
      });
      this.loading = true;
      this.delivarysJobList = [];
      this.urgentJobList = [];
      this.isChangeTab = true;
      this.queryJobList();
    },
    handlePageJump() {
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_joblist2_more",
        moduleName: `${this.componentConfig.sort}|${this.componentConfig.type}`,
        contentName: this.componentConfig.title,
        bcopExrinfo: {
          pagecode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}|${this.curItem?.strategyId}`,
        },
        contentType: "跳转活动页",
      });

      let jumpUrl = "";
      let deeplinkid =
        this.$route.query.deeplinkid || localStorage.getItem("deeplinkid");

      if (this.platform.includes("App")) {
        jumpUrl = this.jumpButtonConfig.jumpLinkDTO.jumpLinkApp;
      } else if (
        this.commonStore.appType == "weixin" &&
        this.platform.indexOf("WX") == -1
      ) {
        jumpUrl = this.jumpButtonConfig.jumpLinkDTO.jumpLinkWx;

        let _jumpurl = this.getUrlBeforeQuestionMark(jumpUrl);
        let params = this.getUrlParams(jumpUrl);
        let query = "";
        if (_jumpurl == "pages/op/index") {
          query =
            `id=${params.id}` + (deeplinkid ? `&deeplinkid=${deeplinkid}` : "");
        } else {
          query = deeplinkid ? `&deeplinkid=${deeplinkid}` : "";
        }
        this.handleMiniLogin(_jumpurl, query);

        return;
      }
      jumpUrl = jumpUrl
        ? jumpUrl
        : this.jumpButtonConfig.jumpLinkDTO.jumpLinkH5;
      location.href = jumpUrl;
    },
    // 获取url问号之前的部分
    getUrlBeforeQuestionMark(url) {
      var index = url.indexOf("?");
      if (index !== -1) {
        return url.substring(0, index);
      } else {
        return url;
      }
    },
    getUrlParams(curl) {
      let url = curl;
      let params = {};
      let queryString = url.split("?")[1] || "";
      let keyValuePairs = queryString.split("&") || [];
      if (keyValuePairs.length > 0) {
        for (var i = 0; i < keyValuePairs.length; i++) {
          var keyValue = keyValuePairs[i].split("=");
          params[decodeURIComponent(keyValue[0])] = decodeURIComponent(
            keyValue[1]
          );
        }
      }
      return params;
    },
    // 小程序跳转
    handleMiniLogin(path, query) {
      const params = {
        from_domain: this.platform.includes("yjs")
          ? "yjs_wxapp"
          : "51job_weixin_wxapp",
        rand: this.generate6DigitUUID(9),
        guid: this.generate6DigitUUID(5),
        wx_biz: {
          path: path,
          query: query,
          expire_type: 1,
          expire_time: new Date().getTime() + 24 * 60 * 60 * 1000,
          expire_interval: 1,
          env_version:
            process.env.NODE_ENV === "production" ? "release" : "trial",
        },
      };

      this.$api.activity.getWxUrl(params).then((res) => {
        const { url_link = {} } = res.resultbody || {};
        if (url_link.errcode == "0") {
          const link = url_link.url_link;
          window.location.href = link;
        } else {
          this.$toast("获取微信短链失败");
        }
      });
    },
    generate6DigitUUID(num) {
      return Math.floor(100000 + Math.random() * (9 * 10 ** num)).toString();
    },
    clickJobCard(item, index) {
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_joblist",
        moduleName: `${this.componentConfig.sort}|${this.componentConfig.type}`,
        contentName: this.componentConfig.title,
        contentType: "职位",
        contentId: item.jobId,
        contentRank: `${index}`,
        bcopExrinfo: {
          pagecode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}|${this.curItem?.strategyId}`,
          subContentRank: `${this.goodRank}`,
        },
      });
      if (this.$base.checkLoginStatus(true)) {
        // 是否配置了职位大卡浏览
        if(this.pageConfig.showJobCard === 1 && this.$store.getters.device !== 'pc' && this.$store.getters.device !== 'wechat'){
          this.showJbsCardPopup(`0-${index}`);
        }else{
          this.$base.toJobDetail(item);
        }
      }
    },
    // 职位大卡展示
    showJbsCardPopup(index) {
      this.$emit("showJbsCardPopup",index,this.curItem.labelName,this.urgentJobList,this.updateJobStatus);
    },
    updateJobStatus(itemObj){//同步大卡投递状态
      this.urgentJobList.some((item) => {
        if (item.jobId == itemObj.jobid) {
          console.log("投递成功之后的item",item,item.jobName)
          item.isApply = itemObj.isApplied;
          this.selectedJobIds = this.selectedJobIds.filter(id => id != item.jobId)
          return true; // 相当于 break
        }
        return false; // 继续循环
      });
    },
    gotoChat(item) {
      if (this.$base.checkLoginStatus(true)) {
        let property = {
          pageCode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}|${this.curItem?.strategyId}`,
          requestId: item.property ? JSON.parse(item.property)?.requestId : ''
        };
        this.$base.goChatNew(item, this.$store.state.commonStore, property);
      }
    },
    // 单投
    gotoDeliver(item, index = -1) {
      if (this.$base.checkLoginStatus(true) && !item.isApply) {
        if (item.isFromXyx) {
          //网申
          this.$base.toJobDetail(item);
        } else {
          // 单投
          const property = (item?.property && JSON.parse(item.property)) || {};
          const params = {
            item: { ...item, jobId: String(item.jobId) },
            property: {
              ...property,
              fromModule: "列表单投",
            },
            isShowToast: "0",
            onSuccess: () => {
              this.$emit("goQuestionSet", [item]);
              this.changeItemIsApply(item);
              this.$store.commit("setValueLocalStorage", {
                applyJobRefreshTasks:
                  this.$store.state.commonStore.applyJobRefreshTasks + 1,
              });

                this.updateJobList(index);
            },
          };
          this.applyJob(params);
        }
      }
    },
    // 单投成功后，列表更新已投递职位
    async updateJobList(index) {
      // 获取下一页数据
      const data = await this.queryJobList("readonly");
      let job = data.filter((item) => {
        return !item.isApply;
      });
      job = job.length ? job[0] : "";

      // 更新数据
      if (job) {
        if (!job.isFromXyx) {
          this.delivarysJobList.push(job);
        }
        this.urgentJobList.splice(index, 1, job);
      }
    },
    handleDeliverys() {
      const newDelivaryJobList = this.delivarysJobList.filter(item =>this.selectedJobIds.includes(item.jobId));
      if (newDelivaryJobList.length > 0) {
        if (this.$base.checkLoginStatus(true)) {
          if (!this.$store.state.commonStore.accountId) {
            this.$toast.fail("投递失败，请先完善简历");
            return false;
          }
          // 需过滤网申和已投递职位
          this.$toast.loading({
            message: "稍等片刻",
            forbidClick: true,
            className: "waiting-apply",
          });
          let item = newDelivaryJobList[0];
          const property = (item?.property && JSON.parse(item.property)) || {};
          this.batchApplyJob({
            jobList: newDelivaryJobList,
            property: {
              ...property,
              // pageCode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}`,
              // shortPageCode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}`,
              fromModule: "列表批投",
            },
            onResult: ({ allSuccess, arrSuccess, arrFail, resultArr }) => {
              console.log(
                "onResult",
                allSuccess,
                arrSuccess,
                arrFail,
                resultArr
              );

              if (allSuccess) {
                this.$toast.clear();
                this.$emit("goQuestionSet", newDelivaryJobList);
                setTimeout(() => {
                  this.urgentJobList = [];
                  this.handleChangeJob();
                }, 1000);
              } else {
                this.$toast.clear();
                this.$toast.fail("部分职位需要进入详情页单独投递~");
              }
              this.$store.commit("setValueLocalStorage", {
                applyJobRefreshTasks:
                  this.$store.state.commonStore.applyJobRefreshTasks + 1,
              });
            },
          });
          return;
        }
      }
    },
    // 投递成功后按钮展示已投递
    changeItemIsApply(item) {
      console.log(
        this.urgentJobList,
        item,
        item.jobId,
        this.urgentJobList.find((job) => job.jobId === item.jobId),
        "changeItemIsApply"
      );
      this.urgentJobList.find((job) => {
        console.log(job.jobId, item.jobId, "changeItemIsApply");
        return job.jobId === item.jobId;
      }).isApply = true;
    },
  },
};